const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';

async function fetchStrapi(endpoint) {
  const res = await fetch(`${STRAPI_URL}/api/${endpoint}?populate=deep`);
  if (!res.ok) throw new Error(`Strapi error: ${res.status}`);
  const json = await res.json();
  return json.data?.attributes ?? json.data ?? null;
}

export const getModuleStandard = () => fetchStrapi('module-standard');
export const getModuleJeune = () => fetchStrapi('module-jeune');
export const getModuleSensibilisation = () => fetchStrapi('module-sensibilisation');
